import { render, staticRenderFns } from "./ArticlePlanning.vue?vue&type=template&id=c585b434"
import script from "./ArticlePlanning.vue?vue&type=script&lang=js"
export * from "./ArticlePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports